import { Reveal, SectionTag } from "./Shared";

const chapters = [
  {
    n: "01",
    title: "The distance tax",
    text: "A leaking tap at 9am in Soho becomes an insurance claim by the time an owner in Singapore wakes up. Time zones compound small issues into expensive ones.",
  },
  {
    n: "02",
    title: "Compliance fog",
    text: "Licensing, tax, and tenancy rules shift by borough and by year. Most owners discover the cost of an error only after the invoice arrives.",
  },
  {
    n: "03",
    title: "Vendor opacity",
    text: "Agents, contractors, and operators quote from an information advantage. Without an independent benchmark, every invoice is a guess.",
  },
  {
    n: "04",
    title: "Yield drift",
    text: "Assets underperform quietly — a rent below market here, a void week there. Left unmeasured, drift slowly becomes the portfolio's whole story.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="border-b border-black/15 bg-[#EBE9E1]">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 py-24 md:py-40">
        <div className="grid lg:grid-cols-12 gap-10 mb-20 md:mb-28">
          <div className="lg:col-span-4">
            <SectionTag testId="manifesto-tag">Why global owners engage us</SectionTag>
          </div>
          <Reveal delay={0.1} className="lg:col-span-8">
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl">
              Owning UK property from afar <em className="font-light">rarely feels passive.</em>
            </h2>
          </Reveal>
        </div>

        <div>
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.06}>
              <div
                data-testid={`manifesto-chapter-${c.n}`}
                className="group relative grid md:grid-cols-12 gap-6 items-baseline py-10 md:py-14 border-t border-black/15 last:border-b overflow-hidden"
              >
                <span
                  aria-hidden="true"
                  className="absolute -top-6 right-0 font-mono text-[8rem] md:text-[11rem] leading-none text-black/[0.05] group-hover:text-[#D4512D]/10 transition-colors duration-700 select-none"
                >
                  {c.n}
                </span>
                <span className="md:col-span-1 font-mono text-xs text-[#D4512D]">{c.n}</span>
                <h3 className="md:col-span-4 font-serif text-3xl md:text-4xl tracking-tight group-hover:translate-x-3 transition-transform duration-500 will-change-transform">
                  {c.title}
                </h3>
                <p className="md:col-span-7 text-base leading-relaxed text-black/55 font-light max-w-2xl">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
